export default __webpack_public_path__ + "static/media/skin1_sprites.6031f1c9.png";